import { render } from "./RecipientsFormEmployee.vue?vue&type=template&id=4778f5b9"
import script from "./RecipientsFormEmployee.vue?vue&type=script&lang=js"
export * from "./RecipientsFormEmployee.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__